import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { mixColors, hexToRgba } from '../utils/colors';
var borderRadius = function borderRadius(edges, theme) {
  switch (edges) {
    case 'rounded':
      return 99;
    case 'sharp':
      return 0;
    default:
      return theme.shape.borderRadius;
  }
};
export var StyledWrapper = styled(Box)(function (_ref) {
  var compact = _ref.compact,
    disabled = _ref.disabled,
    edges = _ref.edges,
    errors = _ref.errors,
    theme = _ref.theme;
  return {
    position: 'relative',
    display: compact === 'yes' ? 'flex' : 'block',
    textAlign: 'center',
    border: "2px dashed " + (errors === 'yes' ? theme.palette.error.main : theme.palette.primary.main),
    padding: compact === 'yes' ? theme.spacing(2, 4) : theme.spacing(6, 4),
    background: disabled ? theme.palette.grey[300] : null,
    opacity: disabled ? 0.5 : 1,
    borderRadius: borderRadius(edges, theme),
    '&:focus': {
      border: "2px solid " + theme.palette.primary.main,
      outline: 'none',
      background: hexToRgba(theme.palette.primary.main, 0.1)
    },
    alignItems: 'center',
    '& .MuiTypography-root': {
      marginRight: compact === 'yes' ? theme.spacing(2) : 0
    }
  };
});
export var StyledDraggingIndicator = styled(LinearProgress)(function (_ref2) {
  var isDragReject = _ref2.isDragReject,
    theme = _ref2.theme;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: 0.2,
    backgroundColor: isDragReject ? theme.palette.error.main : theme.palette.primary.main,
    '& .MuiLinearProgress-barColorPrimary': {
      background: mixColors(isDragReject ? theme.palette.error.main : theme.palette.primary.main, '#ffffff', 60)
    }
  };
});
export var StyledLoader = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -20,
  marginLeft: -20
});
export var StyledIcon = styled('div')(function (_ref3) {
  var compact = _ref3.compact,
    theme = _ref3.theme;
  return {
    display: 'inline-flex',
    color: theme.palette.default.light,
    margin: compact ? "0 " + theme.spacing(2) + " 0 0" : '0 auto',
    fontSize: compact ? '2rem' : '4rem'
  };
});